var React = require('react');

function IconArrowRightDarkInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"11","width":"17","height":"1","fill":"#02242F","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.7929 17.1569L14.5 17.864L20.1569 12.2072L20.864 11.5001L20.1569 10.7929L14.5 5.13609L13.7929 5.8432L19.4497 11.5001L13.7929 17.1569Z","fill":"#02242F","key":1})]);
}

IconArrowRightDarkInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconArrowRightDarkInline;

IconArrowRightDarkInline.default = IconArrowRightDarkInline;
